module.exports = __webpack_public_path__ + "img/13.5c6c223a.png";